export default [
    {
      path: '/customerDetails',
      name: 'customerDetails',
      component: () => import('@/views/sft/CustomerDetails.vue'),
    },
  ]